import { render, staticRenderFns } from "./SearchMentionBox.vue?vue&type=template&id=3015e770&scoped=true&"
import script from "./SearchMentionBox.vue?vue&type=script&lang=ts&"
export * from "./SearchMentionBox.vue?vue&type=script&lang=ts&"
import style0 from "./SearchMentionBox.vue?vue&type=style&index=0&id=3015e770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015e770",
  null
  
)

export default component.exports